import { ArrowLeft02Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { DefaultGlobalNotFound } from "@tanstack/react-router"
import { getStory } from "./stories"
import { Markdown } from "@/ui"
import { ButtonLink } from "@/base"

export type Props = {
  slug: string
}

export default function StoryPage({ slug }: Props) {
  const story = getStory(slug)
  if (!story?.content) {
    return <DefaultGlobalNotFound />
  }

  return (
    <div className="p-8">
      <Markdown className="mx-auto">{story.content}</Markdown>
      <ButtonLink
        variant="ghost"
        className="mt-8 text-sm text-muted-foreground"
        to="/stories"
      >
        <HugeiconsIcon icon={ArrowLeft02Icon} />
        Back to Stories
      </ButtonLink>
    </div>
  )
}
